export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    console.log('GA4 initialized with ID: G-GM24YCHV33');
  }
};

export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-GM24YCHV33', {
      page_path: path,
    });
  }
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

export const trackCustomEvent = (category, action, label = '', value = 0) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
